import React from "react";

import UncheckedSvg from "../../assets/images/icons/off.svg";

export const UncheckedIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={UncheckedSvg}
        alt={alt || "Unchecked"}
    />
);
